import React from 'react';
import { Avatar, AvatarProps } from '../../atoms/Avatar';
import { Typography } from '../../atoms/Typography';
import { makeCSS } from '../../../utils/makeCSS';
import { HBox } from '../../templates/layout/Flex';
import { UserInitial } from '../AvatarGroup';
import { Key } from '../../atoms/Key';
import { SizeVariants } from '../../../theme/themes';

const useCSS = makeCSS(() => ({
  name: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    flexGrow: 1,
    marginLeft: 8
  },
  modifier: {}
}));

export type SuggestionItemStatus = {
  disabled?: boolean;
  active?: boolean;
  disabledReason?: string;
  onClick?: () => void;
};

export type SuggestionType =
  | 'asset'
  | 'project'
  | 'folder'
  | 'contract'
  | 'team'
  | 'email'
  | 'account'
  | 'string';

interface AccountSuggestionItemProps extends Pick<AvatarProps, 'size'> {
  item: UserInitial & SuggestionItemStatus;
  /**  Whether should show a modifier to indicate the shortcut for this option */
  showModifier?: boolean;
}

export default function AccountSuggestionItem(
  props: AccountSuggestionItemProps
) {
  const { item, size, showModifier = true } = props;
  const classes = useCSS();

  if (!item) {
    return null;
  }
  return (
    <HBox align="center" onClick={item.onClick}>
      <Avatar
        userInitial={item.full_name || item.email_address}
        hideTooltip
        imageUrl={item.profile_picture}
        size={size}
      />
      <div className={classes.name}>
        {item.full_name ? (
          <Typography colorVariant={item.disabled ? '03' : '01'} weight="body">
            {item.full_name}
          </Typography>
        ) : null}
        {item.email_address ? (
          <Typography colorVariant={item.disabled ? '03' : '01'} weight="body">
            {item.email_address}
          </Typography>
        ) : null}
      </div>
      {showModifier && item.active && !item.disabled ? (
        <div className={classes.modifier}>
          <Key
            keyCode={'Enter'}
            variant="modifier"
            modifierSize={SizeVariants.md}
          />
        </div>
      ) : null}
      {item.disabled && item.disabledReason ? (
        <Typography colorVariant="03" weight="body" variant={SizeVariants.sm}>
          {item.disabledReason.toUpperCase()}
        </Typography>
      ) : null}
    </HBox>
  );
}
